(() => {
  'use strict';

  if (window.RRRCARTTRIGGERINITIALIZED) return;
  window.RRRCARTTRIGGERINITIALIZED = true;

  const TRIGGER_SELECTOR = '[data-rrr-cart-trigger]';

  /*
   * RRR FIX:
   * Dawn quantity update native #cart-icon-bubble ko refresh karta hai.
   * Custom RRR headers mein woh native element present nahi hai.
   * Isliye unavailable section ko request/render list se remove karte hain.
   */
  function patchDawnCartDrawerItems() {
    const CartDrawerItemsElement =
      customElements.get('cart-drawer-items');

    if (!CartDrawerItemsElement) return;

    const prototype = CartDrawerItemsElement.prototype;

    if (
      prototype.rrrCartSectionsPatched ||
      typeof prototype.getSectionsToRender !== 'function'
    ) {
      return;
    }

    const originalGetSectionsToRender =
      prototype.getSectionsToRender;

    prototype.getSectionsToRender = function () {
      const sections =
        originalGetSectionsToRender.call(this);

      return sections.filter((section) => {
        /*
         * CartDrawer section always required hai.
         * cart-icon-bubble tabhi include hoga jab DOM mein
         * native element genuinely available ho.
         */
        if (section.id !== 'cart-icon-bubble') {
          return true;
        }

        return Boolean(
          document.getElementById('cart-icon-bubble')
        );
      });
    };

    prototype.rrrCartSectionsPatched = true;
  }

  /*
   * cart-drawer-items define hone ke baad safe patch apply hoga.
   */
  customElements
    .whenDefined('cart-drawer-items')
    .then(patchDawnCartDrawerItems)
    .catch((error) => {
      console.error(
        'RRR cart drawer patch failed:',
        error
      );
    });

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function openCartDrawer(trigger) {
    const cartDrawer = getCartDrawer();

    if (
      !cartDrawer ||
      typeof cartDrawer.open !== 'function'
    ) {
      return false;
    }

    cartDrawer.open(trigger);
    return true;
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(
      TRIGGER_SELECTOR
    );

    if (!trigger) return;

    const cartDrawer = getCartDrawer();

    /*
     * Drawer unavailable ho to normal /cart link fallback chalega.
     */
    if (
      !cartDrawer ||
      typeof cartDrawer.open !== 'function'
    ) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    openCartDrawer(trigger);
  });

  document.addEventListener('keydown', (event) => {
    const trigger = event.target.closest(
      TRIGGER_SELECTOR
    );

    if (!trigger || event.code !== 'Space') {
      return;
    }

    const cartDrawer = getCartDrawer();

    if (
      !cartDrawer ||
      typeof cartDrawer.open !== 'function'
    ) {
      return;
    }

    event.preventDefault();
    openCartDrawer(trigger);
  });
})();